import { useState } from 'react';

/**
 * Custom hook para gestionar alertas
 * Solo para formularios de cancelación y finalización (no general)
 * @returns {Object} Estado y funciones de alerta
 */
function useAlert() {
    const [isOpen, setIsOpen] = useState(false);
    const [title, setTitle] = useState('Aviso');
    const [content, setContent] = useState('');

    const show = (alertTitle, alertContent) => {
        setTitle(alertTitle);
        setContent(alertContent);
        setIsOpen(true);
    };

    const close = () => {
        setIsOpen(false);
    };

    return {
        isOpen,
        title,
        content,
        show,
        close
    };
}

export default useAlert;
